// Fixed Uber/Rasier Alabama "Annual Vehicle Inspection" points (20 total),
// matching the official Alabama form. Column split: 1-11 left, 12-20 right.

export const alabamaInspectionPoints = [
  { number: 1, label: "Foot brakes" },
  { number: 2, label: "Emergency brake (parking brake)" },
  { number: 3, label: "Steering mechanism" },
  { number: 4, label: "Windshield" },
  { number: 5, label: "Rear window and other glass" },
  { number: 6, label: "Windshield wipers" },
  { number: 7, label: "Headlights" },
  { number: 8, label: "Tail lights" },
  { number: 9, label: "Turn indicator lights" },
  { number: 10, label: "Brake lights" },
  { number: 11, label: "Front seat adjustment mechanism" },
  { number: 12, label: "Doors (open, close, unlock)" },
  { number: 13, label: "Horn" },
  { number: 14, label: "Speedometer" },
  { number: 15, label: "Bumpers" },
  { number: 16, label: "Muffler and exhaust system" },
  { number: 17, label: "Interior and exterior rearview mirrors" },
  { number: 18, label: "Safety belts and air bags for driver and passenger(s)" },
  { number: 19, label: "Tire condition, including adequate tread depth" },
  { number: 20, label: "Functioning heat and air conditioning" },
];

export const alabamaInspectionColumns = [
  alabamaInspectionPoints.slice(0, 11),
  alabamaInspectionPoints.slice(11),
];

// Resolves PASS/FAIL for a point from the inspection checks (mapped by index).
export const getAlabamaPointStatus = (checksData, index) => {
  const status = checksData?.[index]?.status;
  return {
    pass: status === true || status === 1,
    fail: status === false || status === 0,
  };
};
